import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import { guid } from '@/utils/getCalculatedValue'
import { getSameAttribute } from '@/utils/handleData.js'
import { getDefaultBidOrgUid } from '@/utils/pageParams/progress.js'
const billOfQuantities = {
  billOfQuantities: {
    name: 'billOfQuantities',
    componentTypes: ['navigate', 'check', 'tables', 'stepForm', 'dialogTable'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    headButtons: setCheckButtons(['导入清单']),
    getListFun: 'billOfQuantities/getBillOfQuantities',
    addFun: 'billOfQuantities/addBillOfQuantities',
    editFun: 'billOfQuantities/editBillOfQuantities',
    deleteFun: 'billOfQuantities/deleteBillOfQuantities',
    detailPage: [
      {
        buttonName: '清单复核',
        type: 'tables',
        name: 'billOfReview',
        theme: 'billOfQuantities',
        step: 'billOfReviewList',
        label: '清单复核列表',
        checkType: 'detailData',
        commitFun: 'billOfQuantities/setBillOfReview',
        detailData: (params) => {
          return params.currentRow ? [params.currentRow] : []
        },
        expandAll: true
      },
      {
        code: 'add',
        type: 'stepForm',
        name: 'billOfQuantities',
        theme: 'billOfQuantities',
        step: 'billOfQuantitiesInfo',
        label: '新增工程量清单'
      },
      {
        code: 'edit',
        type: 'stepForm',
        checkType: 'useRowData',
        name: 'billOfQuantities',
        theme: 'billOfQuantities',
        step: 'billOfQuantitiesInfo',
        label: '编辑工程量清单'
      },
      {
        codes: ['upload'],
        type: 'dialogTable',
        name: 'uploadList'
      },
      {
        codes: ['contractAmount', 'billCheckAmount'],
        type: 'expand',
        name: 'billOfQuantities'
      }
    ],
    queryParams: {
      orgUid: (params) => {
        return getDefaultBidOrgUid(params)
      },
      subitemUid: '',
      progressTypeUid: ''
    },
    selectData: [
      {
        key: 'orgUid',
        label: '项目标段名称',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'subitemUid',
        label: '分部分项名称',
        type: 'cascader',
        options: (params) => {
          return params.state.division.subitemList
        },
        placeholder: '请先选择项目标段',
        filterable: true,
        checkStrictly: true,
        showAllLevels: false,
        checkByValue: true,
        emitPath: false
      },
      {
        key: 'progressTypeUid',
        label: '形象进度分项',
        type: 'cascader',
        options: (params) => {
          // 仅形象工程分类（不含最底层分项工程），各层可单选
          return params.getters['progress/boundProgressCategoryTree']
        },
        placeholder: '请先选择项目标段',
        filterable: true,
        showAllLevels: false,
        checkByValue: true,
        checkStrictly: true,
        emitPath: false
      }
    ],
    outListHeight: 260,
    radios: (params) => {
      const projectConfig = params.dictionarys.projectConfig.find((item) => {
        return params.orgType === 'simPro'
          ? item.label === params.getters['user/projectType']
          : item.label === params.state.bidSection.subBidSection[0].projectType
      })
      const listSum = projectConfig ? projectConfig.listSum : []
      var radios = [{ label: '汇总', value: 'sum' }].concat(listSum)
      return radios
    },
    showSummary: true,
    summaryMethod: () => {
      return ({ columns, data }) => {
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '清单合计'
          } else if ((index >= 1 && index <= 3) || index === 5 || index === 7) {
            sums[index] = ''
          } else if (index === 4 || index === 6) {
            sums[index] = getSameAttribute(data, column.property).addValue
          }
        })
        return sums
      }
    },
    tagInfo:
      '施工合同清单中父级汇总清单细目默认单位为空，可通过新增下级操作为其添加下级合同清单；有单位则认为其为最下级合同清单，可按照图纸通过清单复核操作进行清单工程量复核，即批量添加工程量复核清单。',
    rowData: (params) => {
      return params.getters['billOfQuantities/chapterListTree']
    },
    columns: (params) => {
      var columns = [
        {
          prop: 'codeName',
          label: '\xa0\xa0\xa0清单细目&&分部分项',
          width: '500px',
          overflowWidth: 80,
          align: 'left'
        },
        {
          prop: 'unit',
          label: '单位'
        },
        { prop: 'price', label: '单价(元)' },
        { prop: 'contractQuantity', label: '清单合同量' },
        { prop: 'contractAmount', label: '清单合同金额(元)', drillDown: true },
        { prop: 'billCheckQuantity', label: '清单复核量' },
        { prop: 'billCheckAmount', label: '清单复核金额(元)', drillDown: true }
      ]
      if (params.orgType === 'simPro') {
        columns.push({
          label: '操作',
          width: '280px',
          buttons: (params) => {
            return params.radio === 'sum'
              ? setTableButtons(['新增下级', '编辑', '删除'])
              : (row) => {
                  return row.listType === '工程量复核清单'
                    ? setTableButtons(['编辑', '删除'])
                    : row.unit
                    ? setTableButtons(['清单复核', '编辑', '删除'])
                    : setTableButtons(['新增下级', '编辑', '删除'])
                }
          }
        })
      }
      return columns
    },
    addArray: true,
    editArray: true,
    formParams: {
      uid: guid(),
      orgUid: (params) => {
        return params.orgValue
      },
      parentUid: (params) => {
        return params.currentRow ? params.currentRow.uid : params.orgValue
      },
      parentCN: (params) => {
        return params.currentRow
          ? params.currentRow.listBreakdownCN
          : params.orgName
      },
      listType: '施工合同清单',
      listBreakdownCode: '',
      listBreakdownName: '',
      unit: '',
      price: null,
      contractQuantity: null,
      billCheckQuantity: null,
      marker: ''
    },
    formRules: {
      listBreakdownCode: [
        {
          required: true,
          message: '清单细目编码不能为空',
          trigger: 'blur'
        }
      ],
      listBreakdownName: [
        {
          required: true,
          message: '清单细目名称不能为空',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '工程量清单信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'parentCN',
          label: '上一级清单',
          type: 'input',
          disabled: true,
          step: 0
        },
        {
          key: 'listType',
          label: '清单类型',
          type: 'input',
          disabled: true,
          step: 0
        },
        {
          key: 'listBreakdownCode',
          label: '清单细目编码',
          type: 'input',
          disabled: (params) => {
            return (
              (params.radio === 'sum' && params.pageStatus === 'edit') ||
              (params.formValues &&
                params.formValues.listType === '工程量复核清单')
            )
          }
        },
        {
          key: 'listBreakdownName',
          label: '清单细目名称',
          type: 'input',
          disabled: (params) => {
            return (
              params.formValues &&
              params.formValues.listType === '工程量复核清单'
            )
          }
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ||
              (params.radio !== 'sum' &&
                params.pageStatus === 'edit' &&
                params.currentRow &&
                !params.currentRow.children)
              ? 'unit'
              : null
          },
          label: '单位',
          type: 'select',
          options: (params) => {
            return params.dictionarys.unit
          },
          placeholder: '父级汇总合同清单不需选择单位，最下级合同清单必选单位',
          filterable: true,
          create: true,
          clearable: true,
          disabled: (params) => {
            return (
              params.formValues &&
              params.formValues.listType === '工程量复核清单'
            )
          }
        },
        {
          key: (params) => {
            return params.formValues && params.formValues.unit ? 'price' : null
          },
          label: '单价',
          type: 'input',
          inputButton: '元',
          number: 2,
          clearable: true,
          disabled: (params) => {
            return (
              params.formValues &&
              params.formValues.listType === '工程量复核清单'
            )
          }
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.unit &&
              params.formValues.listType === '施工合同清单'
              ? 'contractQuantity'
              : null
          },
          label: '清单合同量',
          type: 'input',
          number: true,
          clearable: true,
          step: 0
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.listType === '工程量复核清单'
              ? 'progressUid'
              : null
          },
          label: '形象进度分项',
          type: 'cascader',
          options: (params) => {
            return params.getters['progress/progressTree']
          },
          filterable: true,
          showAllLevels: false,
          checkByValue: true,
          emitPath: false
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.listType === '工程量复核清单'
              ? 'billCheckQuantity'
              : null
          },
          label: '清单复核量',
          type: 'input',
          number: true,
          clearable: true,
          step: 0
        },
        {
          key: 'marker',
          label: '备注',
          type: 'input',
          step: 0
        }
      ]
    },
    uploadList: {
      name: 'uploadList',
      title: '导入清单',
      width: '70%',
      upload: true,
      rowKey: 'index',
      upLoadFun: 'billOfQuantities/addBillOfQuantities',
      getParentFun: 'billOfQuantities/getBillOfQuantities',
      indexColumn: true,
      columns: [
        { prop: 'listBreakdownCode', label: '清单细目编号', width: '' },
        { prop: 'listBreakdownName', label: '清单细目名称', width: '' },
        { prop: 'subitemCode', label: '分部分项编号', width: '' },
        { prop: 'subitemName', label: '分部分项名称', width: '' },
        { prop: 'unit', label: '单位', width: '' },
        { prop: 'price', label: '单价', width: '' },
        { prop: 'contractQuantity', label: '清单合同量', width: '' },
        { prop: 'billCheckQuantity', label: '清单复核量', width: '' },
        { prop: 'status', label: '数据状态', width: '', overflow: false },
        {
          label: '操作',
          buttons: setTableButtons(['删除']),
          width: '80px'
        }
      ]
    }
  },
  billOfReview: {
    name: 'billOfReview',
    componentTypes: ['navigate', 'check', 'tables'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    saveFun: 'billOfQuantities/editBillOfQuantities',
    getParentFun: 'billOfQuantities/getBillOfQuantities',
    deleteFun: 'billOfQuantities/deleteBillOfQuantities',
    detailPage: [
      {
        buttonName: '保存',
        type: 'goBack'
      }
    ],
    checkType: 'add',
    headButtons: setCheckButtons(['保存']),
    selectOpen: true,
    queryParams: {
      uid: guid(),
      orgUid: (params) => {
        return params.orgValue
      },
      parentUid: (params) => {
        return params.state.currentRow.billOfQuantities
          ? params.state.currentRow.billOfQuantities.uid
          : null
      },
      parentCN: (params) => {
        return params.state.currentRow.billOfQuantities
          ? params.state.currentRow.billOfQuantities.listBreakdownCN
          : null
      },
      listType: '工程量复核清单',
      subitemUid: '',
      progressUid: '',
      progressUids: [],
      listBreakdownCode: (params) => {
        return params.state.currentRow.billOfQuantities
          ? params.state.currentRow.billOfQuantities.listBreakdownCode
          : ''
      },
      listBreakdownName: (params) => {
        return params.state.currentRow.billOfQuantities
          ? params.state.currentRow.billOfQuantities.listBreakdownName
          : ''
      },
      unit: (params) => {
        return params.state.currentRow.billOfQuantities
          ? params.state.currentRow.billOfQuantities.unit
          : ''
      },
      price: (params) => {
        return params.state.currentRow.billOfQuantities
          ? params.state.currentRow.billOfQuantities.price
          : null
      },
      contractQuantity: null,
      billCheckQuantity: 0,
      drawingNo: '',
      marker: ''
    },
    queryRules: {
      progressUids: [
        {
          type: 'array',
          required: true,
          message: '请选择至少一个相关联的形象进度分项',
          trigger: 'change'
        }
      ]
    },
    selectData: [
      {
        key: 'progressUids',
        label: '形象进度分项',
        type: 'cascader',
        options: (params) => {
          return params.getters['progress/progressTree']
        },
        multiple: true,
        filterable: true,
        emitPath: false,
        showAllLevels: false,
        checkByValue: true,
        placeholder: '请根据实际工程批量选择相关进度分项',
        span: 24
      },
      {
        key: 'billCheckQuantity',
        label: '清单复核量',
        type: 'input',
        number: true,
        span: 8
      },
      {
        key: 'drawingNo',
        label: '图纸编号',
        type: 'input',
        span: 8
      },
      {
        key: 'marker',
        label: '备注',
        type: 'input',
        span: 8
      }
    ],
    outListHeight: 220,
    tagInfo:
      '通过在表头表单中批量选择形象进度分项信息，并选择录入共性的复核信息，然后点击“添加”按钮可多次批量添加工程量复核清单；在列表中修改工程量复核清单中个性指标后保存，可完成对所有关联工程量复核清单信息的批量编辑。',
    rowData: (params) => {
      return params.state.billOfQuantities.billOfReview
    },
    columns: [
      {
        prop: 'codeName',
        label: '\xa0\xa0\xa0清单细目&&分部分项',
        width: '500px',
        align: 'left'
      },
      { prop: 'unit', label: '单位' },
      { prop: 'price', label: '单价(元)' },
      { prop: 'contractQuantity', label: '清单合同量', width: '140px' },
      {
        prop: 'billCheckQuantity',
        label: '清单复核量',
        formItem: () => {
          return (row) => {
            return !row.children
              ? {
                  type: 'select',
                  options: row.sizes ? row.sizes : [],
                  filterable: true,
                  create: true,
                  checkByValue: true,
                  optionCustom: true,
                  customKey: 'valueUint'
                }
              : null
          }
        },
        number: true
      },
      {
        prop: 'drawingNo',
        label: '图纸号',
        width: '140px',
        formItem: () => {
          return (row) => {
            return !row.children
              ? {
                  type: 'input'
                }
              : null
          }
        }
      },
      {
        prop: 'marker',
        label: '备注',
        formItem: () => {
          return (row) => {
            return !row.children
              ? {
                  type: 'input'
                }
              : null
          }
        },
        overflow: true
      },
      { label: '操作', width: '140px', buttons: setTableButtons(['删除']) }
    ]
  }
}

export default billOfQuantities
